export default __webpack_public_path__ + "static/media/caixa-logo.84675f1e.svg";